import * as React from 'react'
import { css } from 'react-emotion'

const imageStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Barlow;
  padding: 0;
  border: none;
  width: 80%;
  max-width: 900px;
  margin: 0 auto 1.5rem auto;
  line-height: normal;
  @media screen and (max-width: 808px) {
    width: 100%;
  }
`

interface ImageProps {
    url: string
    caption: string
    credit: string
    alt: string
    /** Custom css for the image component */
    style?: string
}

export class CustomLargeImageC extends React.Component<ImageProps> {
    render() {
        return (
            <figure className={imageStyle}>
                <img
                    className={css`
            margin-bottom: 0;
            width: 100%;
            height: auto;
          `}
                    src={this.props.url}
                    alt={this.props.alt}
                />
                <figcaption>
                    {this.props.caption} ({this.props.credit})
                </figcaption>
            </figure>
        )
    }
}
